<div *ngIf="cart" class="cart-contents">
    <div
        *ngIf="failedProductGtins?.length > 0 || moqViolationsList?.length > 0"
        class="cart-contents__failed-import"
    >
        <ng-container *ngIf="failedProductGtins?.length > 0">
            <p>{{ IMPORT_TEXT.NOT_FOUND_GTINS }}</p>
            <div class="flex flex-col">
                <p *ngFor="let gtin of failedProductGtins" class="text-wrap">
                    {{ gtin }}
                </p>
            </div>
        </ng-container>

        <ng-container *ngIf="moqViolationsList?.length > 0">
            <p [class.mt-3]="failedProductGtins?.length > 0">
                {{ IMPORT_TEXT.MOQ_NOT_MET }}
            </p>
            <div class="flex flex-col">
                <p *ngFor="let violation of moqViolationsList" class="text-wrap">
                    {{ violation.gtin }}
                </p>
            </div>
        </ng-container>
    </div>

    <div class="cart-contents__groups">
        <div
            *ngFor="let group of supplierGroups; trackBy: trackBySupplierGroup"
            class="supplier-group"
            [class.supplier-group--dimmed]="!isGroupIncluded(group)"
        >
            <div class="supplier-group__header">
                <button
                    *ngIf="canEdit && !isConsolidatedFeedGroup(group)"
                    type="button"
                    class="supplier-group__check"
                    [class.supplier-group__check--on]="isGroupIncluded(group)"
                    [attr.title]="'Include this supplier in checkout'"
                    (click)="toggleIncluded(group)"
                    [attr.aria-pressed]="isGroupIncluded(group)"
                >
                    <img
                        *ngIf="isGroupIncluded(group)"
                        src="assets/icons/check.svg"
                        alt=""
                    />
                </button>

                <div class="supplier-group__meta">
                    <div class="supplier-group__title-row">
                        <span class="supplier-group__title">{{
                            getSupplierTitle(group)
                        }}</span>
                        <span
                            class="supplier-group__type"
                            [attr.data-type]="getSupplyTypeKey(group)"
                            >{{ getSupplyTypeLabel(group) }}</span
                        >
                    </div>
                    <div class="supplier-group__sub">
                        {{ group.lines.length }}
                        {{ group.lines.length === 1 ? "product" : "products" }}
                        · {{ group.totalValue | formatPrice }}
                    </div>
                    <div
                        *ngIf="group.volumeDiscountPercentApplied"
                        class="supplier-group__tier"
                    >
                        Volume discount:
                        {{ group.volumeDiscountPercentApplied }}% applied
                    </div>
                </div>

                <div
                    *ngIf="canEdit && !isConsolidatedFeedGroup(group)"
                    class="supplier-group__mov"
                >
                    <div
                        class="supplier-group__bar"
                        [style.background]="getBarTrackColor(group)"
                    >
                        <div
                            class="supplier-group__bar-fill"
                            [style.width.%]="group.progressPercentage"
                            [style.background]="getProgressColor(group)"
                        ></div>
                    </div>
                    <div
                        class="supplier-group__mov-status"
                        [style.color]="getCompactStatusColor(group)"
                    >
                        {{ getCompactStatusLine(group) }}
                    </div>
                </div>

                <a
                    *ngIf="
                        canEdit &&
                        !group.isReadyForCheckout &&
                        !isConsolidatedFeedGroup(group)
                    "
                    class="supplier-group__add-link"
                    [routerLink]="['/category/products/', group.supplierId]"
                    >Add products</a
                >

                <button
                    type="button"
                    class="supplier-group__toggle"
                    (click)="toggleGroupOpen(group)"
                >
                    {{
                        isGroupOpen(group)
                            ? "Hide products"
                            : "Show products"
                    }}
                    <img
                        src="assets/icons/chevron-down-outline.svg"
                        alt=""
                        [class.supplier-group__chevron--open]="isGroupOpen(group)"
                    />
                </button>
            </div>

            <div
                *ngIf="group.promotionDescription"
                class="supplier-group__promotion"
                [style.color]="group.promotionTextColor"
                [innerHTML]="group.promotionDescription"
            ></div>

            <ng-container *ngIf="isGroupOpen(group)">
                <div
                    *ngFor="let line of group.lines; trackBy: trackByFn"
                    class="cart-line"
                >
                    <div class="cart-line__thumb">
                        <img
                            *ngIf="line.featuredAsset; else noImage"
                            [src]="line.featuredAsset | assetPreview : 'thumb'"
                            [alt]="line.productVariant.name"
                            vsfFallbackSrc
                        />
                        <ng-template #noImage>
                            <div class="cart-line__thumb-empty">
                                <img
                                    src="assets/icons/venduro-icon-light-grey.svg"
                                    alt=""
                                />
                            </div>
                        </ng-template>
                    </div>

                    <div class="cart-line__info">
                        <a
                            class="cart-line__name"
                            [routerLink]="[
                                '/product',
                                line.productVariant?.product?.slug,
                                line.productVariant?.pricing?.id
                            ]"
                            >{{ line.productVariant.name | titlecase }}</a
                        >
                        <div class="cart-line__gtin">
                            GTIN
                            {{
                                line.productVariant?.product?.customFields
                                    ?.gtin || "—"
                            }}
                        </div>
                        <div
                            *ngIf="hasMoqViolation(line)"
                            class="cart-line__moq-error"
                        >
                            MOQ not met — minimum {{ getViolatedMoq(line) }}
                            units.
                        </div>
                    </div>

                    <div *ngIf="!isOrderDetail" class="cart-line__avail">
                        <ng-container *ngIf="isLinePreOrder(line); else stock">
                            {{ TEXT.PRE_ORDER }}
                        </ng-container>
                        <ng-template #stock>
                            <span *ngIf="!hasStockLineIssue(line)"
                                >{{ getAvailableStock(line) | number }}
                                available</span
                            >
                            <span
                                *ngIf="hasStockLineIssue(line)"
                                class="cart-line__stock-error"
                                >{{ getStockDisplayText(line) }}</span
                            >
                        </ng-template>
                    </div>

                    <div class="cart-line__price">
                        <div
                            *ngIf="isDiscounted(line)"
                            class="cart-line__price-was"
                        >
                            {{
                                getUndiscountedUnitPrice(line) | formatPrice
                            }}
                        </div>
                        <div class="cart-line__price-now">
                            {{ line.unitPriceWithTax | formatPrice }}
                            <span>/ unit</span>
                        </div>
                    </div>

                    <div class="cart-line__qty-wrap">
                        <div class="qty-control" *ngIf="canAdjustQuantities">
                            <button
                                type="button"
                                class="qty-btn"
                                (click)="decrement(line)"
                                aria-label="Decrease quantity"
                            >
                                −
                            </button>
                            <input
                                type="text"
                                class="qty-input"
                                [value]="line.quantity"
                                (input)="onQuantityChange(line, $event)"
                                [disabled]="!canEdit"
                            />
                            <button
                                type="button"
                                class="qty-btn"
                                (click)="increment(line)"
                                aria-label="Increase quantity"
                            >
                                +
                            </button>
                        </div>
                        <span *ngIf="!canAdjustQuantities" class="cart-line__qty-static">{{
                            line.quantity
                        }}</span>
                        <div *ngIf="getBundleLabel(line)" class="cart-line__bundle">
                            {{ getBundleLabel(line) }}
                        </div>
                    </div>

                    <div class="cart-line__total">
                        {{
                            (isDiscounted(line)
                                ? line.discountedLinePriceWithTax
                                : line.linePriceWithTax
                            ) | formatPrice
                        }}
                    </div>

                    <button
                        *ngIf="canEdit"
                        type="button"
                        class="cart-line__remove"
                        (click)="removeItem(line)"
                        title="Remove"
                        aria-label="Remove item"
                    >
                        <img src="assets/icons/cart-line-remove.svg" alt="" />
                    </button>
                </div>

                <a
                    *ngIf="canEdit && !isConsolidatedFeedGroup(group)"
                    class="supplier-group__inventory-link"
                    [routerLink]="['/category/products/', group.supplierId]"
                >
                    Add more from
                    {{
                        isPreOrder(group)
                            ? "this pricelist"
                            : "Seller " + group.supplierId + "'s inventory"
                    }}
                    <img src="assets/icons/right-arrow-icon.svg" alt="" />
                </a>
            </ng-container>
        </div>
    </div>
</div>

<div *ngIf="!cart || cart.lines.length === 0" class="cart-contents__empty-cart">
    <h2 class="cart-contents__empty-cart-title">Your cart is empty</h2>
    <p class="cart-contents__empty-cart-text">
        Add items to your cart to proceed with checkout.
    </p>
    <button
        [routerLink]="['/']"
        class="btn btn-primary"
        aria-label="Continue shopping"
    >
        Continue Shopping
    </button>
</div>
